import { render, staticRenderFns } from "./CaptionHost.vue?vue&type=template&id=3ea7f106&scoped=true&"
import script from "./CaptionHost.vue?vue&type=script&lang=js&"
export * from "./CaptionHost.vue?vue&type=script&lang=js&"
import style0 from "./CaptionHost.vue?vue&type=style&index=0&id=3ea7f106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea7f106",
  null
  
)

export default component.exports